export { default } from './DeviceBrandChip';
export type { DeviceBrandChipProps } from './DeviceBrandChip';
